import lodash from 'lodash';

import { ACCUSED_KEYS } from 'bundles/author-assignment-grading/components/common/components/GraderModuleSidebar/constants/PlagiarismFlagConstants';
import type {
  CheatingCaseRuling,
  CheatingCaseStaffComment,
} from 'bundles/naptimejs/resources/cheatingCaseStaffComments.v1';
import { CHEATING_CASE_RULINGS } from 'bundles/naptimejs/resources/cheatingCaseStaffComments.v1';

import _t from 'i18n!nls/author-assignment-grading';

export const getLabelForRuling = (ruling?: CheatingCaseRuling): string => {
  let label;
  switch (ruling) {
    case CHEATING_CASE_RULINGS.RESOLVED_NO_CHEATING:
      label = _t('Resolved: No Plagiarism Found');
      break;
    case CHEATING_CASE_RULINGS.RESOLVED_CHEATING:
      label = _t('Resolved: Plagiarism Found');
      break;
    case CHEATING_CASE_RULINGS.UNRESOLVED:
    default:
      label = _t('Unresolved plagiarism');
      break;
  }
  return label;
};

export const getGuiltyMembersFromCheatingCaseComments = (cheatingCaseComments: {
  [caseId: string]: Array<CheatingCaseStaffComment>;
}): Array<number> => {
  // only teams have guilty members and teams can only have one cheating case
  const comments = lodash.values(cheatingCaseComments)[0];
  const lastComment = lodash.last(comments);
  const accused = lastComment && lastComment.accused;
  // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  const accusedTeam = accused && accused[ACCUSED_KEYS.team];
  return accusedTeam && accusedTeam.guiltyMembers;
};

export const mapCommentsToCheatingCases = (comments: Array<CheatingCaseStaffComment> = []) => {
  const commentsByCase = comments.reduce((cases, comment) => {
    const commentId = comment.id;
    const caseId = commentId.split('~')[0];
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    return { ...cases, [caseId]: [...(cases[caseId] || []), comment] };
  }, {});

  // @ts-expect-error TSMIGRATION
  return lodash.mapValues(commentsByCase, (caseComments) => caseComments.sort((a, b) => a.createdAt - b.createdAt));
};
